import * as faker from 'faker';
import React from 'react';
import { Form } from 'react-bootstrap';

export interface ITextInputProps {
  value: string;
  className?: string;
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
  disabled?: boolean;
  maxLength?: number;
  readOnly?: boolean;
  placeholder?: string;
}

export const TextInput = (props: ITextInputProps) => {
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (props.onChange) {
      props.onChange(event.target.value);
    }
  };

  const handleOnBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (props.onBlur) {
      props.onBlur(event.target.value);
    }
  };

  return (
    <Form.Control
      id={`text-input-${faker.random.alphaNumeric(10)}`} // randomize to throw off browser auto-fill of fields
      type="text"
      className={props.className}
      value={props.value}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      disabled={props.disabled}
      maxLength={props.maxLength}
      readOnly={props.readOnly}
      placeholder={props.placeholder}
    />
  );
};

export default TextInput;
